import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BackgroundValidationListView from './BackgroundValidationListView';

const IdentityView = () => (
  <Routes>
    <Route path=":tab" element={<BackgroundValidationListView />} />
    <Route index element={<Navigate to="client" replace />} />
  </Routes>
);

export default IdentityView;
